module.exports = __webpack_public_path__ + "static/media/p1.81b431d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/personalization/images/urbanhipster/p1.jpg
// module id = 2935
// module chunks = 0